<toplayout></toplayout>
<!-- <section class="portal-content p-table leftsidebar-content" (click)="onClickOutside($event)">
  <div class="n_sidebar "  [ngClass]="syncTopMenuClick == false?'sidepanel-collapse':'left-sidebar'" [ngStyle]="{'display': hideLeftmenu}">
    <layout-leftmenu ></layout-leftmenu>
  
  </div>
  <div class="dash-tiles py-3" style="padding: 15px;background: #ffffff;">
        
    <router-outlet></router-outlet>
    
</div>
</section> -->



<!-- <div class="p-2" style="background: #f5f5f5;height: calc(100vh - 61px);overflow: auto;">
  <div class="card mt-1 mb-1" style="box-shadow: 0 1px 3px rgba(0, 0, 0, .05); border: 0;">
     
  </div>
</div> -->




<div class="n-main">
  <div class="new_main">
    <layout-leftmenu ></layout-leftmenu>
    <div class="n_pageBody"> 
      <router-outlet></router-outlet>
       
    </div>
  </div>
</div>

